import { FETCH_BILLING_PLANS, CREATE_BILLING_PLAN, UPDATE_BILLING_PLAN, DELETE_BILLING_PLAN } from "@/store/action-types"
import { cachedActionWrapper } from "@/modules/common/store/tools"
import { SET_BILLING_PLANS } from "@/store/mutation-types"
import { CACHE_BILLING_PLANS } from "@/store/cache-types"

export default {
  namespaced: true,
  state: () => {
    return {
      billingPlans: []
    }
  },
  getters: {
    billingPlans: state => state.billingPlans,
    billingPlanByUrl: state => {
      const ret = {}

      state.billingPlans.forEach(plan => {
        ret[plan.url] = plan
      })

      return ret
    }
  },
  actions: {
    [FETCH_BILLING_PLANS]: async (context) => {
      return cachedActionWrapper(context, CACHE_BILLING_PLANS, async () => {
        const response = await context.rootGetters.restApi.get('/billing/manage/plan/')
        context.commit(SET_BILLING_PLANS, { data: response.data })
      }, async (context) => {
        return false
      })
    },
    [CREATE_BILLING_PLAN]: async (context, { data }) => {
      const response = await context.rootGetters.restApi.post('/billing/manage/plan/', data)
      await context.dispatch(FETCH_BILLING_PLANS, { force: true })
      return response
    },
    [UPDATE_BILLING_PLAN]: async (context, { url, data }) => {
      const response = await context.rootGetters.restApi.patch(url, data)
      await context.dispatch(FETCH_BILLING_PLANS, { force: true })
      return response
    },
    [DELETE_BILLING_PLAN]: async (context, { url }) => {
      const response = await context.rootGetters.restApi.delete(url)
      await context.dispatch(FETCH_BILLING_PLANS, { force: true })
      return response
    },
  },
  mutations: {
    [SET_BILLING_PLANS]: (state, { data }) => {
      state.billingPlans = data
    }
  }
}
